import {ClipLoader} from 'react-spinners'
export const Loader = ({color,size}) => {
  return (
    <ClipLoader color={color} size={size} />
  )
}